import { Trans } from "react-i18next";
import Styles from "../scss/formFields.module.scss"
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import FormSwitchWithText from "../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText";
import FormSmallTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormSmallTextBox";
import { FormPriceFieldTextAlongside } from "../yoello-lib/modules/dynamicForms/CustomFormComponents/FormPriceFieldText";
import { EnableSettingOption } from "../components/profile/EnableSettingOption";
import { FieldFormExtender } from '../yoello-lib/modules/dynamicForms/FieldFormExtender';
import { CollectionPointHeader } from "../components/ordersSetting/Forms/CollectionPointHeader";
import MinumunOrderValue from "../components/profile/MinumunOrderValue";
import { CollectionPointEntity, createCollectionObject } from "../components/ordersSetting/Forms/CollectionPointEntity";
import { createDeliveryFee, DeliveryFeeEntity } from "../components/ordersSetting/Forms/DeliveryFeeEntity";
import { DeliveryFeeHeader } from "../components/ordersSetting/Forms/DeliveryFeeHeader";
import { FormButtonWithText } from "../yoello-lib/modules/dynamicForms/FormComponents/FormButtonWithText";

export const dinInForm = (t: any): IDynamicFormRow[] => {
  return [
    {
      label: "forms.orders.tableService",
      keyName: "table_enabled",
      Component: EnableSettingOption,
      formProps: { secondLabel: "forms.orders.tableServiceInfo", hasStatus: true },
    },
    {
      label: "forms.orders.minprice",
      keyName: "min_dine_in_price",
      Component: MinumunOrderValue,
      formProps: {
        sideLabel: "forms.orders.dineInMinimum",
        secondLabel: 'forms.orders.dineInMinimumInfo'
      },
      inputProperties: {
        type: "number",
        placeholder: "£5.00",
        inputProps: { step: 0.01, min: 0 },
      },
      registerOptions: { min: 0 },
    },
  ];
};
export const preOrderForm = (): IDynamicFormRow[] => {
  return [
    {
      label: "forms.orders.preOrder",
      keyName: "preorders_enabled",
      Component: FormSwitchWithText,
      formProps: {
        secondLabel: "forms.orders.preOrderInfo",
        secondLabelJSX: (
          <Trans i18nKey='forms.settings.preOrder'>
            0<b>1</b>2
          </Trans>
        ),
        hasStatus: true
      },
    },
  ];
};
export const collectionForm = (isDisabled: boolean): IDynamicFormRow[] => {
  return [
    {
      label: "forms.orders.schedule",
      keyName: "pickup_enabled",
      Component: EnableSettingOption,
      className: Styles.EnableFormEntity,
      disabled: isDisabled,
      formProps: { secondLabel: "forms.orders.scheduleinfo", hasStatus: true },
    },
    {
      label: "forms.orders.minprice",
      keyName: "min_collection_price",
      Component: FormPriceFieldTextAlongside,
      formProps: {
        displaySymbol: true,
        sideLabel: "forms.orders.collectionMinimum",
        secondLabel: 'forms.orders.collectionMinimumInfo'
      },
      inputProperties: {
        type: "number",
        placeholder: "£5.00",
        inputProps: { step: 0.01, min: 0 },
      },
      registerOptions: { min: 0 },
    },

  ];
};
export const deliveryForm = (showRadius: boolean): IDynamicFormRow[] => {
  return [
    {
      label: "forms.orders.pickuptakeaway",
      Component: FormSwitchWithText,
      keyName: "delivery_enabled",
      formProps: { secondLabel: "forms.orders.pickuptakeinfo", hasStatus: true },
    },
    {
      label: "forms.orders.maxDeliveryTime",
      keyName: "delivery_max_lead_time",
      Component: FormSmallTextBox,
      formProps: {
        secondLabel: "forms.orders.maxDeliveryTimeInfo",
        sideLabel: "forms.orders.maxDeliveryTime",
      },
      inputProperties: {
        type: "number",
        inputProps: { min: 0 },
      },
      registerOptions: { min: 0, required: true },
    },
    // {
    //   label: "forms.orders.deliveryFee",
    //   keyName: "delivery_charge",
    //   Component: FormPriceFieldTextAlongside,
    //   formProps: {
    //     secondLabel: "forms.orders.deliveryFeeInfo",
    //     sideLabel: "forms.orders.deliveryFee",
    //     displaySymbol: true,
    //   },
    //   inputProperties: {
    //     type: "number",
    //     placeholder: "0",
    //     inputProps: { step: 1, min: 0 },
    //   },
    //   registerOptions: { min: 0, required: false },
    // },
    {
      label: "forms.orders.deliveryMinimum",
      keyName: "min_delivery_price",
      Component: FormPriceFieldTextAlongside,
      formProps: {
        secondLabel: "forms.orders.deliveryMinimumInfo",
        sideLabel: "forms.orders.deliveryMinimum",
        displaySymbol: true,
      },
      inputProperties: {
        type: "number",
        inputProps: { min: 0 },
      },
      registerOptions: { min: 0 }, // TODO: Make into currency display field
    },
    {
      label: "forms.orders.deliveryRadius",
      keyName: "delivery_radius_km",
      Component: FormSmallTextBox,
      formProps: {
        secondLabel: "forms.orders.deliveryRadiusInfo",
        sideLabel: "forms.orders.deliveryRadius",
      },
      inputProperties: {
        type: "number",
        inputProps: { min: 1, step: ".01" },
      },
      registerOptions: {
        min: 1,
      },
      //TODO: add condition to IDynamicFormRow
      //   condition: showRadius,
    }
  ];
};

export const preciseLocationForm = (onPressSetLocation: ()=> void, hasSetLocation: boolean): IDynamicFormRow[] => {
  return [    
    {
      label: "selectLocation.SetAPreciseVenueLocation",
      keyName: "set_precise_venue_location",
      Component: FormButtonWithText,
      formProps: {
        secondLabel: "selectLocation.info",
        sideLabel: "selectLocation.SetAPreciseVenueLocation",
        buttonLable: 'selectLocation.SetAPreciseVenueLocation',
        onPressSetLocation,
        successText: "selectLocation.hasSetLocation",
        failureText: "selectLocation.hasNotSetLocation",
        isSuccess: hasSetLocation
      },
    },
  ];
};

export function pickupForm(isDisabled: boolean): IDynamicFormRow[] {
  return [
    {
      label: "forms.orders.pickup.enablePickup",
      keyName: "pickup_now_enabled",
      Component: EnableSettingOption,
      formProps: { secondLabel: "forms.orders.pickup.enablePickupInfo" },
      disabled: isDisabled,
      className: Styles.EnableFormEntity
    },
    {
      label: "forms.orders.pickup.autoCloseOrders",
      keyName: "pickup_now_auto_close_orders_enabled",
      Component: EnableSettingOption,
      formProps: { secondLabel: "forms.orders.pickup.autoCloseOrdersInfo" },
      className: Styles.EnableFormEntity,
    },
    {
      label: "forms.orders.minprice",
      keyName: "min_pickup_now_price",
      Component: MinumunOrderValue,
      className: Styles.MinumunOrderValueEntity,
      formProps: {
        sideLabel: "forms.orders.pickUpMinimum",
        secondLabel: 'forms.orders.pickUpMinimumInfo'
      },
      inputProperties: {
        type: "number",
        placeholder: "£5.00",
        inputProps: { step: 0.01, min: 0 },
      },
      registerOptions: { min: 0 },
    },

    {
      label: "forms.orders.pickup.collectionPoints",
      keyName: "collection_points",
      Component: FieldFormExtender,
      formProps: {
        rowColumns: <CollectionPointHeader />,
        secondLabel: "forms.orders.pickup.collectionPointsInfo",
        Component: CollectionPointEntity,
        createNewObjectFunction: createCollectionObject,
        buttonLabel: "forms.orders.pickup.buttonLabel"
      },
      gridColumnOptions: {
        rightCol: 2,
        formCol: 10
      },
      isManualErrors: true
    }
  ]
}

export const orderingOptionsForm = (): IDynamicFormRow[] => {
  return [
    {
      label: "forms.orders.orderOnly",
      keyName: "order_only_enabled",
      Component: FormSwitchWithText,
      formProps: {
        secondLabel: "forms.orders.orderOnlyDescription",
        hasStatus: true
      },
    },
    {
      label: "forms.orders.orderAndPay",
      keyName: "order_and_pay_enabled",
      Component: FormSwitchWithText,
      formProps: {
        secondLabel: "forms.orders.orderAndPayDescription",
        hasStatus: true
      },
    },
  ];
};


export function deliveryFeeForm(): IDynamicFormRow[] {
  return [
    {
      label: "",
      keyName: "delivery_fees",
      Component: FieldFormExtender,
      formProps: {
        rowColumns: <DeliveryFeeHeader />,
        Component: DeliveryFeeEntity,
        createNewObjectFunction: createDeliveryFee,
        buttonLabel: "forms.orders.addDeliveryFee",
        secondLabel:"forms.orders.deliveryFeesFormCaption"
      },
      gridColumnOptions: {
        rightCol: 2,
        formCol: 10
      },
      isManualErrors: true,
    }
  ]
}
export const autoAcceptForm = (): IDynamicFormRow[] => {
  return [
    {
      label: "forms.orders.autoAccept.enableTitle",
      keyName: "auto_accept_orders",
      Component: FormSwitchWithText,
      formProps: {
        secondLabel: "forms.orders.autoAccept.secondTitle",
        hasStatus: true
      },
    },
  ];
};

export const asapDeliveryForm = (): IDynamicFormRow[] => {
  return [
    {
      label: "forms.orders.AsapDelivery.title",
      keyName: "asap_delivery_enabled",
      Component: FormSwitchWithText,
      formProps: {
        secondLabel: "forms.orders.AsapDelivery.secondTitle",
        hasStatus: true
      },
    },
  ];
};
